/**
 * The vocabulary of the KM procedure my-act172.km-susun-atur 1.0.0 (planning Phase 3, plan P3-3b D-153): the stages
 * and actions v1 has not named, every input key, deadline, recorded fact and count. Ids with dots are keyed with
 * underscores. Spread into en.ts; names a case variant gives itself still come first.
 */
export default {
  stage: {
    osc_screening: 'OSC pre-screening',
    screening_returned: 'Returned at pre-screening',
    awaiting_registration: 'Awaiting registration',
    cancelled: 'Cancelled',
    technical_review: 'Technical review',
    written_direction: 'Written direction issued (Form A1)',
    rechecking: 'Rechecking amended plans',
    neighbour_notice: 'Neighbour notice and objections',
    recommendation: 'Recommendation paper',
    committee: 'OSC committee (JK OSC)',
    plan_amendment: 'Plan amendment (LDPP)',
    amendment_checking: 'Checking amended plans',
    mpfn_referral: 'Referred to JPN and MPFN',
    approved_pending_issue: 'Approved, awaiting issue',
    final_plan_checking: 'Checking final plans',
    refusal_pending: 'Refused, awaiting the refusal letter',
    granted: 'Granted',
    extension_pending: 'Extension applied for',
    commenced: 'Works commenced',
    completed: 'Completed',
    lapsed: 'Lapsed',
    refused: 'Refused (appeal window open)',
    under_appeal: 'Under appeal',
    refused_final: 'Refused (final)',
    deemed_withdrawn: 'Deemed withdrawn',
    escalated_to_state: 'Referred to the State Authority',
  },
  actions: {
    amend_check_errored: 'Amended plans check could not run',
    amend_check_failed: 'Amended plans check failed',
    amend_check_passed: 'Amended plans check passed',
    amend_check_retry: 'Retry the amended plans check',
    amendment_lapsed: 'Record that the amendment period lapsed',
    amendment_submit: 'Submit amended plans',
    appeal_allowed: 'Record the appeal allowed',
    appeal_dismissed: 'Record the appeal dismissed',
    appeal_grant_decided: 'Record the appeal decision on the grant',
    appeal_grant_decided_commenced: 'Record the appeal decision on the grant (works commenced)',
    appeal_grant_lodged: 'Record an appeal against the grant',
    appeal_grant_lodged_commenced: 'Record an appeal against the grant (works commenced)',
    appeal_grant_set_aside: 'Record the grant set aside on appeal',
    appeal_lodge: 'Record an appeal lodged',
    appeal_window_closed: 'Appeal window closed',
    approval_issue: 'Issue the building plan approval',
    approval_void_with_parent: 'Void with the lapsed planning permission',
    bp_direction_deemed_withdrawn: 'Deemed withdrawn: amendment period missed',
    bp_direction_extend: 'Extend the amendment period',
    bp_direction_reinstate: 'Reinstate the building plan case',
    c1_issue: 'Issue Form C1',
    c2_issue: 'Issue Form C2',
    charge_record: 'Record the development charge',
    check_accept_exceptions: 'Accept the check with exceptions',
    circulate: 'Circulate to agencies',
    committee_approve: 'Record committee approval',
    committee_approve_with_amendments: 'Record approval with plan amendments (LDPP)',
    committee_cancel: 'Record cancellation by the committee',
    committee_carry_over: 'Carry over to the next meeting',
    committee_refuse: 'Record committee refusal',
    committee_table: 'Table at the OSC committee',
    condition_complied: 'Record conditions complied with',
    construction_complete: 'Record completion (CCC)',
    construction_start: 'Record commencement (Form B)',
    decision_finalise: 'Refusal becomes final',
    delegated_approve: 'Approve under delegation',
    delegated_refuse: 'Refuse under delegation',
    direction_comply: 'Record compliance with the direction (Form A2)',
    direction_deemed_withdrawn: 'Deemed withdrawn: direction not complied with',
    direction_extend: 'Extend the direction period',
    direction_issue: 'Issue a written direction (Form A1)',
    direction_reinstate: 'Reinstate the case',
    escalate_to_state: 'Record referral to the State Authority',
    extension_circulate: 'Circulate the extension to agencies',
    extension_recommend: 'Recommend on the extension',
    final_check_errored: 'Final plans check could not run',
    final_check_failed: 'Final plans check failed',
    final_check_passed: 'Final plans check passed',
    final_check_retry: 'Retry the final plans check',
    final_plans_submit: 'Submit final plans',
    hearing_held: 'Record the objection hearing',
    ldpp_letter_issued: 'Record the amendment letter issued',
    mpfn_advised: 'Record the MPFN advice',
    mpfn_refer: 'Refer to JPN and MPFN',
    neighbours_notify: 'Notify neighbours',
    objection_record: 'Record an objection',
    objections_closed: 'Objection period closed',
    paper_submit: 'Submit the recommendation paper',
    paper_submit_after_notice: 'Submit the recommendation paper after the notice',
    parent_withdrawn: 'Withdraw with the withdrawn planning permission',
    permit_apply_extension: 'Apply for an extension',
    permit_extend: 'Grant the extension',
    permit_lapse: 'Permission lapsed',
    permit_refuse_extension: 'Refuse the extension',
    permit_renew: 'Record a renewal',
    prerequisite_record: 'Record a checklist item',
    recheck_errored: 'Recheck could not run',
    recheck_failed: 'Recheck failed',
    recheck_passed: 'Recheck passed',
    recheck_retry: 'Retry the recheck',
    refusal_issue: 'Issue the refusal letter',
    register: 'Register',
    register_building: 'Register the building plan',
    screen_cancel: 'Cancel: completion period missed',
    screen_complete: 'Pre-screening complete',
    screen_expired: 'Completion period expired',
    screen_incomplete: 'Return as incomplete',
    state_approved: 'Record State Authority approval',
    state_refused: 'Record State Authority refusal',
    withdrawal_close: 'Close the withdrawal',
  },
  inputs: {
    advice: 'Advice summary',
    advisedOn: 'Date of the advice',
    amendments: 'Amendments required',
    appealRef: 'Appeal reference',
    appealResult: 'Appeal result',
    appellant: 'Appellant',
    approvalNo: 'Approval letter number',
    approvedOn: 'Approval date',
    boardOrderRef: 'Appeal Board order reference',
    borangBStatus: 'Form B status of the planning permission',
    c1No: 'Form C1 number',
    chargeAmount: 'Charge amount (RM)',
    chargeReceipt: 'Charge receipt number',
    chargeStatus: 'Development charge',
    commencedOn: 'Commencement date (Form B)',
    communicatedOn: 'Date communicated to the applicant',
    completedOn: 'Completion date (CCC)',
    conditionIds: 'Conditions complied with',
    conditions: 'Conditions',
    decidedOn: 'Decision date',
    delegated: 'Decided under delegation',
    directions: 'Directions',
    evidence: 'Evidence',
    extendedOn: 'Extension date',
    extraDays: 'Extra days',
    feeReceipt: 'Fee receipt number',
    filing: 'Filing',
    grounds: 'Grounds',
    hardcopyVerified: 'Hard copies verified',
    heldOn: 'Hearing date',
    isf: 'Infrastructure contribution (ISF) settled',
    issuedOn: 'Issue date',
    kmScale: 'Scale of the planning permission',
    kmValid: 'Planning permission valid',
    letterOn: 'Letter date',
    lodgedOn: 'Lodging date',
    meetingNo: 'Meeting number',
    meetingOn: 'Meeting date',
    noBuildingWorks: 'No building works',
    noLocalPlan: 'No local plan in force',
    note: 'Note',
    objectionReceivedOn: 'Date the objection was received',
    objector: 'Objector',
    objectorNoticeOn: 'Date notice went to the objectors',
    orderOn: 'Order date',
    period: 'Period (days)',
    pjp: 'PJP settled',
    pkt: 'PKT settled',
    praJkOn: 'Pre-committee meeting date',
    proposedConditions: 'Proposed conditions',
    receiptOn: 'Date received',
    receivedOn: 'Date received',
    refusalRef: 'Refusal letter reference',
    refusedOn: 'Refusal date',
    registeredOn: 'Registration date',
    renewalRef: 'Renewal reference',
    renewedOn: 'Renewal date',
    s18Deposit: 'Section 18 deposit or exemption',
    scale: 'Scale',
    scheduledOn: 'Meeting date planned',
    servedOn: 'Service date',
    stampingPlans: 'Plans for stamping received',
    stateDecidedOn: 'State decision date',
    stateRef: 'State letter reference',
    stateRefusalRef: 'State refusal letter reference',
    summary: 'Summary',
    syor: 'Recommendation',
    window: 'Comment window (days)',
    worksNotStopped: 'Works not stopped for more than three months',
  },
  clocks: {
    osc_screening: 'OSC pre-screening',
    applicant_completion: 'Applicant completion',
    circulation: 'Circulation to agencies',
    technical_comment: 'Agency comments',
    kpkt_first_hearing: 'First hearing (KPKT)',
    kpkt_decision: 'Decision (KPKT)',
    paper_due: 'Recommendation paper due',
    written_direction: 'Written direction (Form A2)',
    neighbour_objection: 'Neighbour objections',
    objection_hearing: 'Objection hearing',
    ldpp_amendment: 'Plan amendments (LDPP)',
    bp_direction: 'Building plan amendments',
    bp_decision_window: 'Building plan decision (three months)',
    reinstate_window: 'Reinstatement window',
    documentation: 'Documents after approval',
    appeal_window: 'Appeal window',
    appeal_grace: 'Late appeal grace',
    appeal_window_grant: 'Appeal against the grant',
    validity: 'Validity',
  },
  flags: {
    scale: 'Scale',
    noLocalPlan: 'No local plan in force',
    noticeRequired: 'Neighbour notice required',
    delegated: 'Delegated route',
    noBuildingWorks: 'No building works',
    amendmentLapsed: 'Amendment period lapsed',
    filing: 'Filing',
    objectionsClosed: 'Objection period closed',
    hearingSettled: 'Hearing settled',
    committeeOutcome: 'Committee outcome',
    chargeStatus: 'Development charge',
    chargeSettled: 'Development charge settled',
    stampingPlans: 'Plans for stamping received',
    isf: 'ISF settled',
    kmValid: 'Planning permission valid',
    pjp: 'PJP settled',
    pkt: 'PKT settled',
    s18Deposit: 'Section 18 deposit or exemption',
    grantAppealOpen: 'Appeal against the grant open',
    extensionRecommended: 'Extension recommended',
    appealAllowed: 'Appeal allowed',
  },
  counters: {
    hearings: 'Hearings',
    objections: 'Objections',
    extensions: 'Extensions',
    ldppLetters: 'Amendment letters',
    directionExtensions: 'Direction extensions',
    bpDirectionExtensions: 'Building plan amendment extensions',
    renewals: 'Renewals',
  },
  /** Design Q26 (decided 2026-10-29): the form's notice beside `nama` and `pemaju`, for a plan type the K file reports. */
  form: {
    registerNotice:
      "The developer's name and the development's name are reported to PLANMalaysia in the committed land-use register.",
  },
} as const
